module.exports = __webpack_public_path__ + "static/media/moderately_disagree.b51ad11a.png";